import { fetchData } from '../../utils';
import { ApiResponse } from '../../types';
import {
  MetaTouchpointSetup,
  TiktokTouchpointSetup,
  YouTubeTouchpointSetup,
} from '../../../pages/calculator/MediaPlanning/components/Touchpoints/interfaces';
import { CAMPAIGN } from './mediaPlanning';

export const getYouTubeConfig = async (
  division: string,
  countryISO: string,
  campaignTargetGroup: string,
  campaignScenario: string,
  touchpointTargetGroup?: string
) => {
  return fetchData<ApiResponse<YouTubeTouchpointSetup>>(
    `/${CAMPAIGN}/touchpoints/youtube-setup`,
    {
      params: {
        division,
        countryISO,
        campaignTargetGroup,
        campaignScenario,
        ...(touchpointTargetGroup && { touchpointTargetGroup }),
      },
    }
  );
};

export const getMetaConfig = async (
  division: string,
  brand: string,
  category: string,
  countryISO: string,
  targetGroup: string,
  campaignScenario: string,
  touchpointTargetGroup?: string | null,
  touchpointStartDate?: string | null,
  touchpointLength?: string | null
) => {
  return fetchData<ApiResponse<MetaTouchpointSetup>>(
    `/${CAMPAIGN}/touchpoints/meta-setup`,
    {
      params: {
        division,
        brand,
        category,
        countryISO,
        targetGroup,
        campaignScenario,
        touchpointTargetGroup,
        touchpointStartDate,
        touchpointLength,
      },
    }
  );
};

export const getTiktokConfig = async (
  division: string,
  countryISO: string,
  campaignTargetGroup: string,
  campaignScenario: string,
  touchpointTargetGroup?: string | null
) => {
  return fetchData<ApiResponse<TiktokTouchpointSetup>>(
    `/${CAMPAIGN}/touchpoints/tiktok-setup`,
    {
      params: {
        division,
        countryISO,
        campaignTargetGroup,
        campaignScenario,
        touchpointTargetGroup,
      },
    }
  );
};
